import styled from 'styled-components';
import theme from 'src/theme';

type MainProps = {
    numberOfColumns?: number;
};

export const MainWrapper = styled.div<MainProps>`
    ${(props) => {
        switch (props.numberOfColumns) {
            case 0:
                return 'display: none;';
            case 1:
                return 'grid-template-columns: 100%;';
            case 2:
                return 'grid-template-columns: 74% 26%;';
            case 3:
                return 'grid-template-columns: 37% 37% 25.5%;';
        }
    }}

    display: grid;
    width: 100%;
    height: calc(100% - ${theme.constants.pageHeaderHeight});
    overflow-y: auto;
    grid-gap: 5px;
    padding-right: 5px;
    overflow-x: hidden;
    font-size: 0.8rem;
    select {
        width: 60px;
    }
`;

export const ColumnWrapper = styled.div``;

export const Column = styled.div`
    overflow-x: hidden;
    box-shadow: #ccc 0 2px 6px 2px;
`;

type Props = {
    isVisible?: boolean;
    gridCol?: number;
    gridColSpan?: number;
    isLoading?: boolean;
    numberOfColumns?: number;
    hasSyncError?: boolean;
};

export const SectionWrapper = styled.div<Props>`
    ${(props) => (props.isVisible === false ? 'display: none;' : '')}

    background: #fff;
    position: relative;
    h4 {
        color: #524c06;
        border-bottom: 1px solid #e1e7d4;
        margin: 0 0 0.5rem;
    }
    ${(props) => {
        if (props.gridCol && props.gridColSpan) {
            return `grid-column: ${props.gridCol} / span ${props.gridColSpan};`;
        }
        if (props.gridCol) {
            return `grid-column: ${props.gridCol};`;
        }
        return '';
    }}
`;

export const SectionContent = styled.div<Props>`
    padding: 5px;
    margin: 0 0 1rem;
    position: relative;
    ${(props) => (props.isVisible === false ? 'display: none;' : '')}
`;

export const SectionHeaderComponent = styled.div<Props>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
    font-weight: bold;
    color: #00447e;
    background: #e4e4e4;
    .close-button {
        margin-right: 0.5rem;
    }
`;

export const SubSectionHeader = styled.div<Props>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9rem;
    text-transform: uppercase;
    color: #0aa5dc;
    font-weight: 500;
    letter-spacing: 0;
    padding: 0 0 0 10px;

    ${(props) => (props.hasSyncError ? `color: red;` : '')}
`;

export const UnitSelection = styled.div<Props>`
    flex: 0 0 80px;
    display: flex;
    justify-content: space-between;
`;

export const SectionInnerWrapper = styled.div`
    margin: 5px 0 10px;

    .error-text {
        margin-top: 0;
        margin-bottom: 1rem;

        button {
            margin-left: 0.5rem;
        }
    }
`;

export const SectionInnerGridWrapper = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 45% 45%;
    grid-gap: 50px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-gap: 2px;
    button {
        &:hover {
            background: #eee;
        }
        &:disabled,
        &[disabled] {
            cursor: unset;
        }
        .status-icon {
            margin-left: 3px;
            font-size: 10px;
        }
    }
`;

export const HeaderStyle = styled.div`
    font-size: 0.8rem;
    font-weight: 500;
    background: #dbddd4;
    color: #524c06;
    padding: 0.1rem 0.25rem;
    margin: 0 0 0.5rem;
`;

export const ListHeaderStyle = styled.div`
    font-size: 0.8rem;
    font-weight: 500;
    text-align: center;
    background-color: #f4f4f4;
    border-bottom: 2px solid ${theme.legacyColors.headingColor};
    color: #00447e;
    margin: 0 0 0.5rem;
`;

export const FullSceenSectionWrapper = styled.div``;
